import { serviceCatalogEn } from "./yuxelServiceCatalog.en";
// Exact Azerbaijani copy from YUXEL Website Services Master Prompt. Do not rewrite without approval.
export const yuxelServiceIntro = {
  "eyebrow": "YUXEL / XİDMƏTLƏR",
  "headline": "İdeyadan icraya. Məlumatdan qərara.",
  "description": "Strategiya qururuq, marketinqi idarə edirik, kreativ işlər hazırlayırıq. AI və avtomatlaşdırma ilə biznes proseslərini daha sistemli işləyən hala gətiririk.\n\nAyrı-ayrı xidmətlər təklif edirik. Amma onların birlikdə necə işlədiyini də düşünürük."
};
export const yuxelServiceAreas = [
  {
    "id": "marketing",
    "label": "Marketinq və böyümə",
    "headline": "Marketinqin hər tərəfi. Tək bir hissəsi yox.",
    "intro": "Strategiyadan reklamın icrasına, brenddən e-ticarətə, ənənəvi kanallardan rəqəmsal analitikaya qədər marketinqin bütün əsas istiqamətlərində işləyirik.\n\nHarada görünmək lazım olduğunu düşünürük. Necə görünməyi planlayırıq. Nəticəni də diqqətdən qaçırmırıq.",
    "categoryIds": [
      "M01",
      "M02",
      "M03",
      "M04",
      "M05",
      "M06",
      "M07",
      "M08"
    ],
    "cta": {
      "heading": "Marketinqdə nəyi dəyişmək istəyirsiniz?",
      "text": "Strategiyadan icraya qədər biznesinizə uyğun xidmətləri birlikdə müəyyənləşdirək.",
      "label": "Layihəni müzakirə edək"
    }
  },
  {
    "id": "ai",
    "label": "AI və avtomatlaşdırma",
    "headline": "AI-ni sadəcə danışdırmırıq. İş prosesinə qoşuruq.",
    "intro": "Müştəri müraciətlərindən satış hesabatlarına, sənəd dövriyyəsindən maliyyə proseslərinə qədər AI və avtomatlaşdırma həlləri layihələndiririk.\n\nHər prosesə AI tətbiq etmək lazım deyil. Əvvəl işi təhlil edir, sonra harada AI, harada adi avtomatlaşdırma, harada isə insan qərarı lazım olduğunu müəyyənləşdiririk.",
    "categoryIds": [
      "A01",
      "A02",
      "A03",
      "A04",
      "A05",
      "A06",
      "A07",
      "A08"
    ],
    "cta": {
      "heading": "Biznesinizdə hansı işi avtomatlaşdırmaq olar?",
      "text": "Mövcud prosesi və istifadə etdiyiniz sistemləri qiymətləndirək. Harada AI, harada avtomatlaşdırma lazım olduğunu müəyyənləşdirək.",
      "label": "AI imkanlarını müzakirə edək"
    }
  }
];
export const yuxelServiceCategories = [
  {
    "id": "M01",
    "title": "MARKETİNQ STRATEGİYASI VƏ İDARƏETMƏ",
    "short": "Strategiya",
    "intro": "Hara getdiyimizi bilmədən reklama başlamırıq.",
    "services": [
      {
        "id": "M01-01",
        "number": "01",
        "title": "Marketinq strategiyası",
        "description": "Biznesin məqsədlərinə, bazara və hədəf auditoriyaya uyğun marketinq istiqaməti müəyyənləşdiririk.",
        "icon": "Target",
        "iconConcept": "Strategic target."
      },
      {
        "id": "M01-02",
        "number": "02",
        "title": "Marketinq auditi və bazar araşdırması",
        "description": "Mövcud fəaliyyətləri, rəqibləri, auditoriyanı və bazar imkanlarını təhlil edirik. Qərarları fərziyyə ilə məhdudlaşdırmırıq.",
        "icon": "FileSearch",
        "iconConcept": "Magnifying glass over report."
      },
      {
        "id": "M01-03",
        "number": "03",
        "title": "Marketinq planlaması və büdcə",
        "description": "Kampaniyaları, kanalları, resursları və büdcəni planlaşdırırıq. Nəyin, nə vaxt və nə üçün ediləcəyi aydın olur.",
        "icon": "CalendarDays",
        "iconConcept": "Planning calendar."
      },
      {
        "id": "M01-04",
        "number": "04",
        "title": "Məhsulun bazara çıxarılması — Go-to-Market",
        "description": "Yeni məhsul və xidmətlərin bazara təqdimatı üçün mövqeləndirmə, kommunikasiya və satışa dəstək planı hazırlayırıq.",
        "icon": "Rocket",
        "iconConcept": "Product launch arrow."
      }
    ]
  },
  {
    "id": "M02",
    "title": "BREND VƏ KOMMUNİKASİYA",
    "short": "Brend",
    "intro": "Brendi sadəcə tanıtmaq yox, yadda saxlamaq üçün qururuq.",
    "services": [
      {
        "id": "M02-05",
        "number": "05",
        "title": "Brend strategiyası və mövqeləndirmə",
        "description": "Brendin kimə, nə təklif etdiyini və rəqiblərindən nə ilə fərqləndiyini müəyyənləşdiririk.",
        "icon": "Fingerprint",
        "iconConcept": "Distinctive fingerprint."
      },
      {
        "id": "M02-06",
        "number": "06",
        "title": "Brend kimliyi və arxitekturası",
        "description": "Brendin vizual, verbal və struktur kimliyini formalaşdırır, məhsul və alt-brendlər arasındakı əlaqələri sistemləşdiririk.",
        "icon": "Shapes",
        "iconConcept": "Connected brand shapes."
      },
      {
        "id": "M02-07",
        "number": "07",
        "title": "Kommunikasiya strategiyası",
        "description": "Brendin nəyi, kimə, hansı kanalda və hansı üslubda deməli olduğunu planlaşdırırıq.",
        "icon": "MessagesSquare",
        "iconConcept": "Speech bubbles with direction."
      },
      {
        "id": "M02-08",
        "number": "08",
        "title": "PR və reputasiya idarəetməsi",
        "description": "Brendin ictimai kommunikasiya və media münasibətlərini planlayır, reputasiyanın sistemli idarə olunmasına dəstək veririk.",
        "icon": "Newspaper",
        "iconConcept": "Newspaper and message."
      }
    ]
  },
  {
    "id": "M03",
    "title": "RƏQƏMSAL MARKETİNQ",
    "short": "Rəqəmsal",
    "intro": "Onlayn görünmək asandır. Düzgün auditoriyaya çatmaq daha vacibdir.",
    "services": [
      {
        "id": "M03-09",
        "number": "09",
        "title": "Rəqəmsal reklam kampaniyaları",
        "description": "Google, Meta və uyğun rəqəmsal platformalarda reklam strategiyası, kampaniya qurulması, idarəetmə və optimallaşdırma həyata keçiririk.",
        "icon": "Megaphone",
        "iconConcept": "Digital advertisement pointer."
      },
      {
        "id": "M03-10",
        "number": "10",
        "title": "SEO — Axtarış sistemləri üçün optimallaşdırma",
        "description": "Veb-saytın axtarış sistemlərində daha yaxşı görünməsi üçün texniki, məzmun və struktur optimallaşdırması aparırıq.",
        "icon": "Search",
        "iconConcept": "Search result."
      },
      {
        "id": "M03-11",
        "number": "11",
        "title": "Sosial media marketinqi",
        "description": "Sosial media strategiyası, kontent planlaması, səhifə idarəetməsi, icma kommunikasiyası və performans təhlilini həyata keçiririk.",
        "icon": "Share2",
        "iconConcept": "Social connection network."
      },
      {
        "id": "M03-12",
        "number": "12",
        "title": "Email və SMS marketinqi",
        "description": "Müştəri bazasına uyğun kampaniyalar, avtomatik kommunikasiya ardıcıllıqları və təkrar əlaqə mexanizmləri qururuq.",
        "icon": "Mail",
        "iconConcept": "Envelope and notification."
      },
      {
        "id": "M03-13",
        "number": "13",
        "title": "Influencer və tərəfdaşlıq marketinqi",
        "description": "Brendə uyğun kontent yaradıcıları və tərəfdaşlarla əməkdaşlıq kampaniyaları planlaşdırır və idarə edirik.",
        "icon": "Users",
        "iconConcept": "Connected people."
      }
    ]
  },
  {
    "id": "M04",
    "title": "KREATİV VƏ KONTENT",
    "short": "Kreativ",
    "intro": "Yaxşı ideyanın işi yalnız diqqət çəkmək deyil. Nəsə deməkdir.",
    "services": [
      {
        "id": "M04-14",
        "number": "14",
        "title": "Kreativ strategiya və kampaniya konseptləri",
        "description": "Brendin məqsədinə uyğun reklam ideyaları, kampaniya konseptləri və kreativ istiqamətlər hazırlayırıq.",
        "icon": "Lightbulb",
        "iconConcept": "Idea bulb."
      },
      {
        "id": "M04-15",
        "number": "15",
        "title": "Kontent strategiyası və kopiraytinq",
        "description": "Brendin dilinə uyğun mətnlər, sosial media kontenti, reklam mesajları və kommunikasiya planları hazırlayırıq.",
        "icon": "PenLine",
        "iconConcept": "Editorial pen."
      },
      {
        "id": "M04-16",
        "number": "16",
        "title": "Qrafik dizayn və reklam materialları",
        "description": "Rəqəmsal və çap mühitləri üçün brendə uyğun vizual kommunikasiya və reklam materialları hazırlayırıq.",
        "icon": "PenTool",
        "iconConcept": "Design pen tool."
      },
      {
        "id": "M04-17",
        "number": "17",
        "title": "Foto və video istehsalının kreativ idarə olunması",
        "description": "Reklam çəkilişlərinin konseptini, art direction istiqamətini və istehsal prosesini uyğun tərəfdaşlarla koordinasiya edirik.",
        "icon": "Clapperboard",
        "iconConcept": "Camera and film frame."
      }
    ]
  },
  {
    "id": "M05",
    "title": "ƏNƏNƏVİ MARKETİNQ",
    "short": "Ənənəvi",
    "intro": "Marketinq yalnız ekranlarda baş vermir.",
    "services": [
      {
        "id": "M05-18",
        "number": "18",
        "title": "Televiziya və radio reklamları",
        "description": "TV və radio kampaniyalarının strategiyasını, media planlamasını, reklam materiallarını və yerləşdirmə prosesini idarə edirik.",
        "icon": "Tv",
        "iconConcept": "Television and radio signal."
      },
      {
        "id": "M05-19",
        "number": "19",
        "title": "Outdoor və OOH reklamları",
        "description": "Bilbord, şəhər reklamları və digər açıq hava reklam kanalları üzrə planlama və yerləşdirmə işlərini həyata keçiririk.",
        "icon": "PanelsTopLeft",
        "iconConcept": "Outdoor advertising panel."
      },
      {
        "id": "M05-20",
        "number": "20",
        "title": "Çap reklamları və media yerləşdirmələri",
        "description": "Jurnal, qəzet, kataloq, broşür və digər çap reklam materiallarının hazırlanmasını və yerləşdirilməsini təşkil edirik.",
        "icon": "BookOpen",
        "iconConcept": "Printed publication."
      },
      {
        "id": "M05-21",
        "number": "21",
        "title": "Tədbir və BTL marketinqi",
        "description": "Brend aktivləşdirmələri, təqdimatlar, tədbirlər, promoaksiyalar və birbaşa auditoriya ilə təmas kampaniyaları planlaşdırırıq.",
        "icon": "Ticket",
        "iconConcept": "Event ticket."
      },
      {
        "id": "M05-22",
        "number": "22",
        "title": "Trade Marketing və satış nöqtəsi kommunikasiyası",
        "description": "Məhsulların satış nöqtələrində təqdimatını, promoaktivlikləri və ticarət kanalları üzrə marketinq fəaliyyətlərini planlaşdırırıq.",
        "icon": "Store",
        "iconConcept": "Retail shelf."
      }
    ]
  },
  {
    "id": "M06",
    "title": "E-COMMERCE MARKETING",
    "short": "E-commerce",
    "intro": "Onlayn mağazada baxış sayı qədər alış prosesi də vacibdir.",
    "services": [
      {
        "id": "M06-23",
        "number": "23",
        "title": "E-commerce marketinq strategiyası",
        "description": "Onlayn satış kanalları, məhsul təqdimatı, müştəri cəlbi və təkrar alış üçün marketinq planı hazırlayırıq.",
        "icon": "ShoppingCart",
        "iconConcept": "Shopping cart with strategy lines."
      },
      {
        "id": "M06-24",
        "number": "24",
        "title": "Marketplace marketinqi",
        "description": "Uyğun marketplace platformalarında məhsul yerləşdirmələrini, görünürlüğü, reklamları və satışa dəstək fəaliyyətlərini idarə edirik.",
        "icon": "Store",
        "iconConcept": "Digital storefront."
      },
      {
        "id": "M06-25",
        "number": "25",
        "title": "Məhsul kataloqu və məhsul səhifələrinin optimallaşdırılması",
        "description": "Məhsul adlarını, təsvirlərini, vizuallarını, kateqoriyaları və məhsul səhifələrini alış qərarına uyğun təkmilləşdiririk.",
        "icon": "Package",
        "iconConcept": "Product package and detail sheet."
      },
      {
        "id": "M06-26",
        "number": "26",
        "title": "E-commerce reklam kampaniyaları",
        "description": "Onlayn mağazalar üçün məhsul reklamları, remarketing və satış məqsədli rəqəmsal kampaniyalar qururuq.",
        "icon": "ShoppingBag",
        "iconConcept": "Shopping bag with advertising arrow."
      },
      {
        "id": "M06-27",
        "number": "27",
        "title": "E-commerce konversiya optimallaşdırması",
        "description": "Məhsul səhifəsindən ödəniş mərhələsinə qədər alış prosesini təhlil edir, maneələri müəyyənləşdirir və yaxşılaşdırma imkanları hazırlayırıq.",
        "icon": "MousePointerClick",
        "iconConcept": "Checkout conversion path."
      },
      {
        "id": "M06-28",
        "number": "28",
        "title": "Təkrar satış və müştəri loyallığı",
        "description": "Müştəri məlumatları əsasında təkrar alış kampaniyaları, loyallıq mexanizmləri və fərdiləşdirilmiş kommunikasiya planlaşdırırıq.",
        "icon": "RefreshCcw",
        "iconConcept": "Circular shopping arrows."
      }
    ]
  },
  {
    "id": "M07",
    "title": "B2B MARKETING & GROWTH",
    "short": "B2B Growth",
    "intro": "B2B-də hər müraciət eyni deyil. Hər qərar da bir gündə verilmir.",
    "services": [
      {
        "id": "M07-29",
        "number": "29",
        "title": "B2B marketinq strategiyası",
        "description": "Şirkətlərarası satış modelinə uyğun auditoriya, kommunikasiya, kanal və müştəri cəlbi strategiyası hazırlayırıq.",
        "icon": "Building2",
        "iconConcept": "Connected organizations."
      },
      {
        "id": "M07-30",
        "number": "30",
        "title": "Lead Generation və Lead Nurturing",
        "description": "Potensial müştərilərin cəlb edilməsi, ilkin qiymətləndirilməsi və satışa hazır olana qədər əlaqənin davam etdirilməsi proseslərini qururuq.",
        "icon": "ListFilter",
        "iconConcept": "Lead funnel."
      },
      {
        "id": "M07-31",
        "number": "31",
        "title": "Account-Based Marketing — ABM",
        "description": "Seçilmiş şirkətlər və qərarvericilər üçün fərdiləşdirilmiş B2B marketinq kampaniyaları planlaşdırırıq.",
        "icon": "Target",
        "iconConcept": "Targeted company account."
      },
      {
        "id": "M07-32",
        "number": "32",
        "title": "Marketinq və satışın əlaqələndirilməsi",
        "description": "Marketinqdən gələn müraciətlərin satış komandasına ötürülməsi, izlənməsi və nəticələrin birlikdə qiymətləndirilməsi proseslərini qururuq.",
        "icon": "GitMerge",
        "iconConcept": "Interlocking arrows."
      }
    ]
  },
  {
    "id": "M08",
    "title": "MARKETİNQ ANALİTİKASI VƏ MÜŞTƏRİ TƏCRÜBƏSİ",
    "short": "Analitika",
    "intro": "Rəqəmlər çox şey deyir. Düzgün sual verəndə.",
    "services": [
      {
        "id": "M08-33",
        "number": "33",
        "title": "Marketinq analitikası və hesabatlılıq",
        "description": "Kampaniya nəticələrini, xərcləri, müraciətləri və uyğun kommersiya göstəricilərini təhlil edən hesabat sistemi qururuq.",
        "icon": "ChartNoAxesCombined",
        "iconConcept": "Analytics chart."
      },
      {
        "id": "M08-34",
        "number": "34",
        "title": "CRM və müştəri bazasının idarə olunması",
        "description": "CRM strategiyasını, müştəri məlumatlarının strukturunu, seqmentasiyanı və marketinq kommunikasiyası ilə əlaqəsini planlaşdırırıq.",
        "icon": "Database",
        "iconConcept": "Customer database."
      },
      {
        "id": "M08-35",
        "number": "35",
        "title": "Müştəri təcrübəsi və Customer Journey",
        "description": "Müştərinin brendlə ilk təmasından alış və sonrakı mərhələlərə qədər keçdiyi yolu təhlil edir, təkmilləşdirmə imkanlarını müəyyənləşdiririk.",
        "icon": "Route",
        "iconConcept": "Customer journey route."
      },
      {
        "id": "M08-36",
        "number": "36",
        "title": "Veb-sayt, landing page və konversiya optimallaşdırması",
        "description": "Marketinq məqsədli veb-sayt və açılış səhifələrini planlaşdırır, istifadəçi təcrübəsini və müraciət prosesini təkmilləşdiririk.",
        "icon": "AppWindow",
        "iconConcept": "Browser window with cursor."
      },
      {
        "id": "M08-37",
        "number": "37",
        "title": "Marketinq eksperimentləri və Growth Optimization",
        "description": "Mesajları, auditoriyaları, kanalları və istifadəçi təcrübəsi variantlarını test edir, qərarları ölçülə bilən nəticələr əsasında yaxşılaşdırırıq.",
        "icon": "FlaskConical",
        "iconConcept": "Split-test experiment."
      }
    ]
  },
  {
    "id": "A01",
    "title": "AI SALES & REVENUE",
    "short": "AI Sales",
    "intro": "Müraciət almaq işin başlanğıcıdır. Davamını da sistem idarə etməlidir.",
    "services": [
      {
        "id": "A01-01",
        "number": "01",
        "title": "AI Lead-to-Sale Engine",
        "description": "Sayt, sosial mesajlaşma kanalları və formalardan gələn müraciətləri toplayan, təsnif edən, CRM-ə ötürən və satış əməkdaşlarına yönləndirən sistem.",
        "icon": "MessageSquareText",
        "iconConcept": "Incoming message connected to CRM."
      },
      {
        "id": "A01-02",
        "number": "02",
        "title": "AI Deal Recovery Agent",
        "description": "CRM-də gecikmiş geri dönüşləri və dayanmış satış fürsətlərini müəyyən edən, növbəti addımları təklif edən və təsdiqlənmiş əlaqə proseslərini avtomatlaşdıran həll.",
        "icon": "RefreshCcw",
        "iconConcept": "Sales opportunity with follow-up reminder."
      },
      {
        "id": "A01-03",
        "number": "03",
        "title": "AI Sales Conversation Intelligence",
        "description": "İcazəli satış danışıqlarını təhlil edərək müştəri etirazlarını, təkrarlanan sualları və satış prosesində inkişaf imkanlarını müəyyən edən sistem.",
        "icon": "MessagesSquare",
        "iconConcept": "Conversation with analytical markers."
      },
      {
        "id": "A01-04",
        "number": "04",
        "title": "AI Proposal & Tender Assistant",
        "description": "Müştəri tələblərini və təsdiqlənmiş şirkət məlumatlarını təhlil edərək kommersiya təklifləri və tender cavabları üçün ilkin sənədlər hazırlayan AI köməkçisi.",
        "icon": "FileText",
        "iconConcept": "Structured proposal document."
      },
      {
        "id": "A01-05",
        "number": "05",
        "title": "AI Revenue Forecasting",
        "description": "Tarixi satış və CRM məlumatları əsasında gəlir ssenariləri hazırlayan və potensial satış risklərini göstərən analitik həll.",
        "icon": "TrendingUp",
        "iconConcept": "Revenue forecast chart."
      }
    ]
  },
  {
    "id": "A02",
    "title": "AI MARKETING & GROWTH",
    "short": "AI Marketing",
    "intro": "Marketinq nəticələrini sadəcə toplamaq yox, başa düşmək lazımdır.",
    "services": [
      {
        "id": "A02-06",
        "number": "06",
        "title": "AI Marketing Intelligence Center",
        "description": "Reklam platformaları, veb-analitika və CRM məlumatlarını birləşdirərək marketinq və satış göstəricilərinin əlaqəli təhlilini təmin edən sistem.",
        "icon": "ChartNoAxesCombined",
        "iconConcept": "Connected marketing data sources."
      },
      {
        "id": "A02-07",
        "number": "07",
        "title": "AI Campaign Performance Analyst",
        "description": "Reklam kampaniyalarındakı qeyri-adi dəyişiklikləri aşkarlayan, nəticələri təhlil edən və optimallaşdırma tövsiyələri hazırlayan həll.",
        "icon": "ChartLine",
        "iconConcept": "Campaign chart with anomaly marker."
      },
      {
        "id": "A02-08",
        "number": "08",
        "title": "AI Creative Intelligence",
        "description": "Reklam kreativlərinin nəticələrini müqayisə edən, işləyən mesajları və formatları təhlil edərək yeni kreativ briflərin hazırlanmasını dəstəkləyən sistem.",
        "icon": "Lightbulb",
        "iconConcept": "Creative layout with analysis annotation."
      },
      {
        "id": "A02-09",
        "number": "09",
        "title": "AI Customer Segmentation Engine",
        "description": "Müştəriləri mövcud alış və davranış məlumatlarına əsasən qruplaşdıran və daha uyğun marketinq kommunikasiyasının planlaşdırılmasını dəstəkləyən həll.",
        "icon": "Users",
        "iconConcept": "Segmented customer groups."
      },
      {
        "id": "A02-10",
        "number": "10",
        "title": "AI Competitor & Market Intelligence",
        "description": "Açıq mənbələrdən rəqiblər və bazar dəyişiklikləri haqqında məlumatları toplayan, təhlil edən və strukturlaşdırılmış xülasələr hazırlayan sistem.",
        "icon": "Search",
        "iconConcept": "Market intelligence search."
      }
    ]
  },
  {
    "id": "A03",
    "title": "AI FINANCE & CFO",
    "short": "AI Finance",
    "intro": "Maliyyə məlumatı vaxtında görünəndə qərar vermək də asanlaşır.",
    "services": [
      {
        "id": "A03-11",
        "number": "11",
        "title": "AI CFO Copilot",
        "description": "Maliyyə məlumatlarını təhlil edən, idarəetmə hesabatları hazırlamağa və əsas göstəriciləri izah etməyə kömək edən AI sistemi.",
        "icon": "Wallet",
        "iconConcept": "Financial report with analytical assistant."
      },
      {
        "id": "A03-12",
        "number": "12",
        "title": "AI Invoice Processing",
        "description": "Fakturalardan məlumatları çıxaran, uyğunluq yoxlamalarını dəstəkləyən və sənədləri təsdiq mərhələlərinə yönləndirən avtomatlaşdırma həlli.",
        "icon": "Receipt",
        "iconConcept": "Invoice with verified fields."
      },
      {
        "id": "A03-13",
        "number": "13",
        "title": "AI Receivables & Collection Agent",
        "description": "Müştəri borclarını və ödəniş tarixlərini izləyən, gecikmələri müəyyən edən və təsdiqlənmiş ödəniş xatırlatmalarını avtomatlaşdıran sistem.",
        "icon": "CalendarDays",
        "iconConcept": "Payment calendar and reminder."
      },
      {
        "id": "A03-14",
        "number": "14",
        "title": "AI Cash Flow Forecasting",
        "description": "Maliyyə məlumatlarına əsasən mümkün pul axını ssenarilərini hesablayan və likvidlik risklərinin qiymətləndirilməsini dəstəkləyən həll.",
        "icon": "ChartLine",
        "iconConcept": "Cash flow projection."
      },
      {
        "id": "A03-15",
        "number": "15",
        "title": "AI Margin & Cost Intelligence",
        "description": "Məhsul, xidmət və əməliyyatlar üzrə xərc, marja və mənfəətlilik göstəricilərini təhlil edərək qərarverməni dəstəkləyən sistem.",
        "icon": "Scale",
        "iconConcept": "Cost and margin comparison."
      }
    ]
  },
  {
    "id": "A04",
    "title": "AI CUSTOMER EXPERIENCE",
    "short": "AI Customer Experience",
    "intro": "Müştəri üçün hər müraciət yenidir. Şirkət üçün proses təkrarlana bilər.",
    "services": [
      {
        "id": "A04-16",
        "number": "16",
        "title": "AI Omnichannel Service Agent",
        "description": "İnteqrasiya olunmuş mesajlaşma və dəstək kanallarından gələn sorğuları cavablandıran, müraciətləri yönləndirən və lazım olduqda əməkdaşa ötürən AI sistemi.",
        "icon": "Headphones",
        "iconConcept": "Connected customer communication channels."
      },
      {
        "id": "A04-17",
        "number": "17",
        "title": "AI Voice Receptionist",
        "description": "Telefon zənglərində müəyyən edilmiş ssenarilər üzrə danışan, sorğuları qəbul edən, görüş proseslərini dəstəkləyən və zərurət olduqda operatora yönləndirən səsli AI həlli.",
        "icon": "PhoneCall",
        "iconConcept": "Telephone handset with voice lines."
      },
      {
        "id": "A04-18",
        "number": "18",
        "title": "AI Customer Retention Engine",
        "description": "Müştəri davranışlarını təhlil edərək əlaqəsi zəifləyən müştəriləri müəyyənləşdirməyə və uyğun yenidən əlaqə kampaniyaları planlaşdırmağa kömək edən sistem.",
        "icon": "RefreshCcw",
        "iconConcept": "Returning customer arrow."
      },
      {
        "id": "A04-19",
        "number": "19",
        "title": "AI Voice of Customer Analytics",
        "description": "Müştəri rəylərini, şikayətləri və geribildirimləri təhlil edərək təkrarlanan problemləri və xidmətin təkmilləşdirilməsi imkanlarını göstərən həll.",
        "icon": "MessageSquareText",
        "iconConcept": "Feedback speech bubble with analysis."
      }
    ]
  },
  {
    "id": "A05",
    "title": "AI OPERATIONS & WORKFLOW AUTOMATION",
    "short": "AI Operations",
    "intro": "Hər gün təkrarlanan iş, hər gün əl ilə görülməli deyil.",
    "services": [
      {
        "id": "A05-20",
        "number": "20",
        "title": "AI Document Workflow Automation",
        "description": "Sənədlərdən məlumatları çıxaran, onları təsnif edən və müəyyən edilmiş qaydalara uyğun yoxlama və təsdiq mərhələlərinə yönləndirən sistem.",
        "icon": "Files",
        "iconConcept": "Document workflow."
      },
      {
        "id": "A05-21",
        "number": "21",
        "title": "AI Internal Knowledge Assistant",
        "description": "Şirkətin icazə verilmiş daxili sənədləri və bilik bazası əsasında əməkdaşların suallarına mənbəli cavablar tapmağa kömək edən AI köməkçisi.",
        "icon": "BookOpen",
        "iconConcept": "Search within knowledge books."
      },
      {
        "id": "A05-22",
        "number": "22",
        "title": "AI Project Operations Agent",
        "description": "Layihə tapşırıqlarını, son tarixləri və icra statuslarını izləyən, gecikmələri göstərən və idarəetmə xülasələri hazırlayan sistem.",
        "icon": "ListTodo",
        "iconConcept": "Task timeline with status markers."
      },
      {
        "id": "A05-23",
        "number": "23",
        "title": "AI IT Helpdesk Agent",
        "description": "Daxili texniki müraciətləri təsnif edən, dəstək tapşırıqları yaradan və uyğun texniki həll təlimatlarını təqdim edən AI sistemi.",
        "icon": "Headset",
        "iconConcept": "Technical support ticket."
      }
    ]
  },
  {
    "id": "A06",
    "title": "AI HR & PEOPLE OPERATIONS",
    "short": "AI HR",
    "intro": "HR komandasının vaxtı yalnız sənəd izləməklə keçməməlidir.",
    "services": [
      {
        "id": "A06-24",
        "number": "24",
        "title": "AI Recruitment Operations",
        "description": "Vakansiya müraciətlərinin toplanması, namizəd məlumatlarının strukturlaşdırılması və işə qəbul prosesinin inzibati koordinasiyası üçün AI dəstəyi.",
        "icon": "UserRoundSearch",
        "iconConcept": "Candidate file and checklist."
      },
      {
        "id": "A06-25",
        "number": "25",
        "title": "AI Employee Onboarding",
        "description": "Yeni əməkdaşların sənədlərini, tanışlıq materiallarını, tapşırıqlarını və adaptasiya mərhələlərini əlaqələndirən avtomatlaşdırma sistemi.",
        "icon": "ClipboardList",
        "iconConcept": "New employee onboarding checklist."
      },
      {
        "id": "A06-26",
        "number": "26",
        "title": "AI Learning & Training Assistant",
        "description": "Daxili təlim materialları və təsdiqlənmiş bilik mənbələri əsasında əməkdaşların öyrənmə prosesini dəstəkləyən AI köməkçisi.",
        "icon": "GraduationCap",
        "iconConcept": "Open learning book with search."
      }
    ]
  },
  {
    "id": "A07",
    "title": "AI PROCUREMENT & SUPPLY CHAIN",
    "short": "AI Procurement",
    "intro": "Satınalmada təkcə qiyməti deyil, qərarın əsasını da görmək lazımdır.",
    "services": [
      {
        "id": "A07-27",
        "number": "27",
        "title": "AI Supplier Comparison",
        "description": "Təchizatçılardan gələn təklifləri qiymət, şərtlər və müəyyən edilmiş meyarlar əsasında strukturlaşdıran və müqayisə edən AI həlli.",
        "icon": "GitCompare",
        "iconConcept": "Side-by-side supplier quotations."
      },
      {
        "id": "A07-28",
        "number": "28",
        "title": "AI Inventory & Demand Forecasting",
        "description": "Tarixi satış, stok və tələbat məlumatları əsasında mümkün tələb ssenariləri hazırlayan və ehtiyat planlamasını dəstəkləyən sistem.",
        "icon": "Boxes",
        "iconConcept": "Inventory boxes and forecast line."
      },
      {
        "id": "A07-29",
        "number": "29",
        "title": "AI Purchase Approval Workflow",
        "description": "Satınalma sorğularını büdcə limitləri, səlahiyyət qaydaları və təsdiq mərhələləri üzrə yönləndirən avtomatlaşdırma həlli.",
        "icon": "CheckCheck",
        "iconConcept": "Purchase request with approval check."
      }
    ]
  },
  {
    "id": "A08",
    "title": "AI EXECUTIVE INTELLIGENCE",
    "short": "AI Executive",
    "intro": "Rəhbərə daha çox hesabat yox, daha aydın mənzərə lazımdır.",
    "services": [
      {
        "id": "A08-30",
        "number": "30",
        "title": "AI CEO Command Center",
        "description": "Satış, marketinq, maliyyə və əməliyyat məlumatlarını əlaqələndirərək əsas biznes göstəricilərini vahid idarəetmə mühitində təqdim edən həll.",
        "icon": "LayoutDashboard",
        "iconConcept": "Integrated executive overview."
      },
      {
        "id": "A08-31",
        "number": "31",
        "title": "AI Executive Reporting Agent",
        "description": "Müxtəlif şöbə və sistemlərdən məlumatları toplayan, rəhbərlik üçün dövri hesabatlar və əsas dəyişikliklərin xülasələrini hazırlayan AI sistemi.",
        "icon": "FileBarChart",
        "iconConcept": "Consolidated executive report."
      },
      {
        "id": "A08-32",
        "number": "32",
        "title": "AI Business Scenario Intelligence",
        "description": "Mövcud biznes məlumatları və müəyyən edilmiş fərziyyələr əsasında alternativ qərar ssenarilərini modelləşdirən və onların mümkün təsirlərini müqayisə edən analitik həll.",
        "icon": "GitBranch",
        "iconConcept": "Branching business scenarios."
      }
    ]
  }
];
export const yuxelServiceFooter = {
  "heading": "Xidmət seçməzdən əvvəl problemi anlayaq.",
  "text": "Bəzən bir xidmət kifayət edir. Bəzən isə bir neçə prosesin birlikdə işləməsi lazımdır. Hansının doğru olduğunu biznesinizin ehtiyacına görə müəyyənləşdirək.",
  "label": "YUXEL ilə əlaqə saxlayın"
};

export function getServiceCatalog(lang) { return lang === "en" ? serviceCatalogEn : { areas: yuxelServiceAreas, categories: yuxelServiceCategories, footer: yuxelServiceFooter }; }
